import type { Order } from "@aurelia/types";
import { Badge } from "@aurelia/ui";
import {
  ORDER_STATUS_LABELS,
  PAYMENT_STATUS_LABELS,
  orderStatusTone,
  paymentMethodLabel,
  paymentStatusTone
} from "./orderPresentation";

export function OrderStatusBadges({ order }: { order: Order }) {
  return (
    <div className="flex flex-wrap gap-2" aria-label="Order and payment statuses">
      <Badge tone={orderStatusTone(order.status)}>{ORDER_STATUS_LABELS[order.status]}</Badge>
      <Badge tone={paymentStatusTone(order.paymentStatus)}>{PAYMENT_STATUS_LABELS[order.paymentStatus]}</Badge>
      <Badge tone="neutral">{paymentMethodLabel(order)}</Badge>
    </div>
  );
}
